<ng-template>
  <div
    class="tw-pl-7 tw-inline-block tw-border-0 tw-border-l tw-border-solid tw-border-secondary-300 tw-w-10/12"
  >
    <ng-content></ng-content>
  </div>
</ng-template>
